import React from "react";
import { Button } from "../../../designSystem/button/Button";
import { Flex, Grid } from "../../../designSystem/compositeComponents/FlexHelpers";
import { SelectField } from "../../../designSystem/formField/SelectField";
import { TextField } from "../../../designSystem/formField/text/TextField";
import { TextSaveField } from '../../../designSystem/formField/text/TextSaveField';
import { TextAreaField } from "../../../designSystem/formField/textArea/TextAreaField";
import { Select } from "../../../designSystem/inputs/Select";
import { TextArea } from "../../../designSystem/inputs/TextArea";
import { TextAreaWithSave } from "../../../designSystem/inputs/TextAreaWithSave";
import { TextInput } from "../../../designSystem/inputs/TextInput";
import { TextInputWithSave } from "../../../designSystem/inputs/TextInputWithSave";
import { H2 } from "../../../designSystem/typography/Heading";


export const FormComponentsOverview = (): JSX.Element => {

    return (
        <Flex flexDirection="column" gap={64}>
            <H2>Form components</H2>

            <Grid gap={16} gridTemplateColumns={2}>
                <Flex flexDirection="column" gap={24}>
                    <H2>Textinput</H2>
                    <Flex alignItems="flex-end" gap={16}>
                        <TextInput value="TextInput" onChange={() => { return; }} />
                        <Button
                            variant="filled"
                            text="Go click"
                            icon={"add_circle"} 
                            emphasize
                            />
                    </Flex>

                    <Flex alignItems="flex-end" gap={16}>
                        <TextField
                            label="Label"
                            value="TextField"
                            onChange={() => { return; }}
                            size={"42px"}
                        />
                        <Button
                            variant="filled"
                            text="Ring bell"
                            icon={"facility_reception"} />
                    </Flex>
                </Flex>
                <Flex flexDirection="column" gap={24}>
                    <H2>Textinput with save</H2>
                    <Flex alignItems="flex-end" gap={16}>
                        <TextInputWithSave
                            value="TextInputWithSave"
                            onChange={() => { return; }}
                            onSave={() => { return; }}
                            size={"42px"}
                        />
                    </Flex>
                    <Flex alignItems="flex-end" gap={16}>
                        <TextSaveField
                            label={"Vigtig felt!"}
                            value="TextSaveField"
                            onChange={() => { return; }}
                            onSave={() => { return; }}
                        />
                    </Flex>
                </Flex>
            </Grid>


            <Grid gap={16} gridTemplateColumns={2}>
                <Flex flexDirection="column" gap={24}>
                    <H2>TextArea</H2>

                    <Flex alignItems="flex-end" gap={16}>
                        <TextArea
                            value="TextArea"
                            onChange={() => { return; }}
                        />

                        <Button
                            variant="filled"
                            text="filled" />
                    </Flex>

                    <Flex alignItems="flex-end" gap={16}>
                        <TextAreaField
                            label="Label"
                            value="TextAreaField"
                            onChange={() => { return; }}
                        />
                        <Button
                            variant="filled"
                            text="filled" />
                    </Flex>
                </Flex>
                <Flex flexDirection="column" gap={24}>
                    <H2>TextArea with Save</H2>
                    <Flex alignItems="flex-end" gap={16}>
                        <TextAreaWithSave
                            value="TextAreaWithSave 1"
                            onChange={() => { return; }}
                            onSave={() => { return; }}
                        />


                    </Flex>
                    <Flex alignItems="flex-end" gap={16}>
                        <TextAreaWithSave
                            value="TextAreaWithSave 2"
                            onChange={() => { return; }}
                            onSave={() => { return; }}
                        />

                    </Flex>

                </Flex>
            </Grid>


            <Grid gap={16} gridTemplateColumns={2}>
                <Flex flexDirection="column" gap={24}>
                    <H2>Select</H2>

                    <Flex alignItems="flex-end" gap={16}>
                        <Select
                            options={[
                                { value: '1', text: 'Grøn mango' },
                                { value: '2', text: 'Rød mango' },
                                { value: '3', text: 'Gul mango' }
                            ]}
                            selectedValue={"Teks1"}
                            onChange={() => { return; }}
                            width={"200px"}
                        />
                        <Button
                            variant="filled"
                            text="Choose selected" />
                    </Flex>

                    <Flex alignItems="flex-end" gap={16}>

                        <SelectField
                            label="SelectField"
                            options={[
                                { value: '1', text: 'Grøn ananas' },
                                { value: '2', text: 'Rød ananas' },
                                { value: '3', text: 'Gul ananas' }
                            ]}
                            selectedValue={"SelectField"}
                            onChange={() => { return; }}
                            width={"200px"}
                        />
                        <Button
                            variant="filled"
                            text="Go with this one" />
                    </Flex>
                </Flex>
                <Flex flexDirection="column" gap={24}>

                </Flex>
            </Grid>

            <Grid gap={16} gridTemplateColumns={2}>
                <Flex flexDirection="column" gap={24}>
                    <H2>Combos</H2>

                    <Flex gap={16}>

                        <TextInput value="TextInput" onChange={() => { return; }} />

                        <Select
                            options={[
                                { value: '1', text: 'Select 1' },
                                { value: '2', text: 'Select 2' },
                                { value: '3', text: 'Select 3' }
                            ]}
                            selectedValue={"2"}
                            onChange={() => { return; }}
                            width={"auto"} />

                        <Button
                            variant="filled"
                            text="Filter from this"
                            icon={"actions_plus"} />
                    </Flex>



                    <Flex gap={16} alignItems="flex-start">
                        <TextField
                            label="Label"
                            value="TextField"
                            onChange={() => { return; }} />

                        <TextSaveField
                            reserveLabelSpace={true}
                            label=""
                            value="TextSaveField no label"
                            onChange={() => { return; }}
                            onSave={() => { return; }} />

                        <TextSaveField
                            label={"Vigtigt felt!"}
                            value="TextSaveField"
                            onChange={() => { return; }}
                            onSave={() => { return; }} />
                    </Flex>


                    <Flex gap={16} alignItems="flex-end">
                        <TextArea
                            value="TextArea"
                            onChange={() => { return; }} />

                        <Select
                            options={[
                                { value: '1', text: 'Select Æble' },
                                { value: '2', text: 'Select Pære' },
                                { value: '3', text: 'Select Kokosnød' }
                            ]}
                            selectedValue={"2"}
                            onChange={() => { return; }} />
                    </Flex>

                    <Flex gap={16}>
                        <SelectField
                            label="SelectField"
                            options={[
                                { value: '1', text: 'SelectField' },
                                { value: '2', text: 'SelectField' },
                                { value: '3', text: 'SelectField' }
                            ]}
                            selectedValue={"SelectField"}
                            onChange={() => { return; }} />
                        <TextSaveField
                            reserveLabelSpace={true}
                            label=""
                            value="TextSaveField no label"
                            onChange={() => { return; }}
                            onSave={() => { return; }} />
                    </Flex>
                </Flex>
                
            </Grid>

        </Flex>
    );
}